module.exports = __webpack_public_path__ + "img/mail.adabbe1f.svg";